/*
const generateSrcset = (image, widths = []) => {
	const imageUrl = new URL(image["src"]);
	return widths
		.filter((width) => width <= image["width"])
		.map((width) => {
			imageUrl.searchParams.set("width", width.toString());
			return `${imageUrl.href} ${width}w`;
		})
		.join(", ");
};

const createImageElement = (image, classes, sizes, productTitle) => {
	const previewImage = image["preview_image"];
	const newImage = new Image(previewImage["width"], previewImage["height"]);
	newImage.className = classes;
	newImage.alt = image["alt"] || productTitle;
	newImage.sizes = sizes;
	newImage.src = previewImage["src"];
	newImage.srcset = generateSrcset(
		previewImage,
		[165, 360, 533, 720, 940, 1066]
	);
	newImage.loading = "lazy";
	return newImage;
};*/

const checkSwatches = () => {
	document.querySelectorAll(".js-color-swatches-wrapper").forEach((wrapper) => {
		wrapper.querySelectorAll(".js-color-swatches label").forEach((input) => {
			input.addEventListener("click", (event) => {
				const color = input.getAttribute('val')
				console.log('color '+color)
				const product = input.getAttribute('product')
				const secondProduct = input.getAttribute('secondproduct')
				// console.log(input)
				console.log('.media-'+product+'.second-product-'+secondProduct)
				$('.media-' + product).attr('style','object-fit: contain;z-index: 0;')
				$('.media-'+product+'.second-product-'+secondProduct).css('display','block')
				$('.media-'+product+'.second-product-'+secondProduct).first().css('opacity','1')
				$('.media-' + product).not($('.media-' + product + '.second-product-'+secondProduct)).css('display','none')
				let url = $(input).attr('url')
				var productCard = $(input).closest('.collection-product-card');
				productCard.find('label').removeClass('round-border')
				$(input).addClass('round-border')
				console.log(url)
				productCard.find('a').each(function() {
					$(this).attr('href', url);
				});
				var variantsInfo = JSON.parse(document.getElementById('variants_data_'+product).textContent);
				let sizes = []
				let productPrice
				let productCompare
				let mainProduct
                let isAvailable = false
				for(const variant of variantsInfo){
					if(variant.product == secondProduct){
                      console.log(variant)
                      if(variant.available){
                        isAvailable = true
                      }
						if(variant.available){
							sizes.push(variant.title)
							productPrice = variant.product_price
							productCompare = variant.product_compare_at_price
							mainProduct = variant.main
						}
					}
				}
				console.log(sizes)
				$(input).closest('.collection-product-card').find('.size__modal').empty()
                if(isAvailable){
                  for(const size of sizes){
                      $(input).closest('.collection-product-card').find('.size__modal').append('<div class="size__btn" data-variantcolor="'+color+'" data-product="'+product+'" data-secondproduct="'+secondProduct+'" data-variantsize="'+size+'">'+size+'</div>')
                  }
                  $(input).closest('.collection-product-card').find('.badge-out-of-stock').addClass('d-none')
                }
                else{
                  $(input).closest('.collection-product-card').find('.size__modal').append('<div class="out-of-stock">AGOTADO</div>')
                  $(input).closest('.collection-product-card').find('.badge-out-of-stock').removeClass('d-none')
                }
				console.log($('.product-card-'+ mainProduct +' .price'))
				if(productCompare){console.log('Hay compare')
					$('.product-card-'+ mainProduct +' .price-item.price-item--regular').text(productCompare)
					$('.product-card-'+ mainProduct +' .price-item.price-item--sale').text(productPrice)
					$('.product-card-'+ mainProduct +' .price__sale').css('display','flex')
					$('.product-card-'+ mainProduct +' .price__regular').css('display','none')
					$('.product-card-'+ mainProduct +' .price').addClass('price--on-sale')
                   $('.product-card-'+ mainProduct +' .discount-badge').css('display','flex')
					$('.product-card-'+ mainProduct +' .discount-badge').text('-'+Math.ceil(100 - (parseFloat(productPrice.replace('$ ', '').replace(',', '')) * 100 / parseFloat(productCompare.replace('$ ', '').replace(',', ''))))+'%')
				}
				else{
                   $('.product-card-'+ mainProduct +' .discount-badge').css('display','none')
					$('.product-card-'+ mainProduct +' .price-item.price-item--regular').text(productPrice)
					$('.product-card-'+ mainProduct +' .price').removeClass('price--on-sale')
					$('.product-card-'+ mainProduct +' .price__sale').css('display','none')
					$('.product-card-'+ mainProduct +' .price__regular').css('display','flex')
				}
				quickPurchase()
				/*
				const primaryImage = wrapper.querySelector(".media--first");
				const secondaryImage = wrapper.querySelector(".media--second");
				const handleProduct = wrapper.dataset.product;

				if (event.currentTarget.checked && primaryImage) {
					wrapper
						.querySelector(".js-color-swatches-link")
						.setAttribute("href", event.currentTarget.dataset.variantLink);
					const currentColor = event.currentTarget.value;

					jQuery.getJSON(
						window.Shopify.routes.root + `products/${handleProduct}.js`,
						function (product) {
							const variant = product.variants.filter(
								(item) =>
									item.featured_media != null &&
									item.options.includes(currentColor)
							)[0];
							if (variant) {
								const newPrimaryImage = createImageElement(
									variant["featured_media"],
									primaryImage.className,
									primaryImage.sizes,
									product.title
								);

								if (newPrimaryImage.src !== primaryImage.src) {
									let flag = false;
									if (secondaryImage) {
										const secondaryImagePathname = new URL(secondaryImage.src).pathname;
										const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

										if (secondaryImagePathname == newPrimaryImagePathname) {
											primaryImage.remove();
											secondaryImage.classList.remove("media--second");
											secondaryImage.classList.add("media--first");
											flag = true;
										}
									}
									if (flag == false) {
										primaryImage.animate(
											{ opacity: [1, 0] },
											{ duration: 200, easing: "ease-in", fill: "forwards" }
										).finished;
										setTimeout(function () {
											primaryImage.replaceWith(newPrimaryImage);
											newPrimaryImage.animate(
												{ opacity: [0, 1] },
												{ duration: 200, easing: "ease-in" }
											);
											if (secondaryImage) {
												secondaryImage.remove();
											}
										}, 200);
									}
								}
							}
						}
					);
				}
				*/
			});
		});
	});
	hideColorOptions()
};

const quickPurchase = () => {
	// $('.quick_add_btn').off('click').on('click', function() {
	// 	$(this).closest('.collection-product-card').find('.size__modal').toggleClass('op-1');
	//   });
	$('.size__btn').off('click').on('click', async function() {
      console.log('Entra al quick')
	  const color = $(this).attr('data-variantcolor');
	  const size = $(this).attr('data-variantsize');
	  const product = $(this).attr('data-product');
	  const secondProduct = $(this).attr('data-secondproduct');
	  var variantsInfo = JSON.parse(document.getElementById('variants_data_' + product).textContent);
		// console.log('Entra al quick')
	  for (const variant of variantsInfo) {
			if(variant.product == secondProduct){
				// console.log(variant)
				if (variant.title == size) {
					// console.log(variant.id);
                    let currentCart = await PCgetCurrentCart()
                    let hasGift = await PCcheckForGift(currentCart)
                    if(hasGift){
                        PChandleErrorMessage(product,"No puedes agregar un producto si tienes una Gift Card en tu carrito");
                        return
                    }
    				PChandleErrorMessage(product)

					let config = fetchConfig("javascript");
					config.headers["X-Requested-With"] = "XMLHttpRequest";
					delete config.headers["Content-Type"];
					const cart = document.querySelector("cart-drawer")
					const formData = new FormData();
					formData.append('TALLA', size);
					formData.append('form_type', 'product'); 
					formData.append('id', variant.id);
					formData.append('quantity', '1');
					formData.append('properties[color]', color);
					formData.append('product-id', product);
					if (cart) {
						formData.append(
							"sections",
							cart.getSectionsToRender().map((section) => section.id)
						);
						formData.append("sections_url", window.location.pathname);
						cart.setActiveElement(document.activeElement);
					}
					config.body = formData;
					fetch(`${routes.cart_add_url}`, config)
						.then((response) => response.json())
						.then((response) => {
  console.log('Antes de hacer upload')
							ncaddToken()
							uploadCart() 
                          executeInCartUpdate()
							if (response.status) {
								publish(PUB_SUB_EVENTS.cartError, {
									source: "product-form",
									productVariantId: formData.get("id"),
									errors: response.description,
									message: response.message,
								});
								PChandleErrorMessage(response.description);

								const soldOutMessage =
									this.submitButton.querySelector(".sold-out-message");
								if (!soldOutMessage) return;
								this.submitButton.setAttribute("aria-disabled", true);
								this.submitButton.querySelector("span").classList.add("hidden");
								soldOutMessage.classList.remove("hidden");
								this.error = true;
								return;
							} else if (!cart) {
								window.location = window.routes.cart_url;
								return;
							}

							if (!this.error)
								publish(PUB_SUB_EVENTS.cartUpdate, {
									source: "product-form",
									productVariantId: formData.get("id"),
								});
							this.error = false;
							const quickAddModal = this.closest("quick-add-modal");
							if (quickAddModal) {
								document.body.addEventListener(
									"modalClosed",
									() => {
										setTimeout(() => {
											cart.renderContents(response);
										});
									},
									{ once: true }
								);
								quickAddModal.hide(true);
							} else {
								cart.renderContents(response);
							}
						})
						.catch((e) => {
							console.error(e);
						})
				}
			}
	  }
	});
};

$(document).ready(function(){
	hideColorOptions()
})

function hideColorOptions(){
	$('.product-form__controls').on("mouseover",function(){
		if($(this).find(".more-elements")){
			$(this).find(".extra-element").each(function(){
				$(this).css('display','block')
			})
			$(this).find(".more-elements").css('display','none')
		}
	})
	$('.product-form__controls').on("mouseout",function(){
		if($(this).find(".more-elements")){
			$(this).find(".extra-element").each(function(){
				$(this).css('display','none')
			})
			$(this).find(".more-elements").css('display','block')
		}
	})
}


function colorSwatches() {
	checkSwatches();
	quickPurchase();

	document.addEventListener("shopify:section:load", function () {
		checkSwatches();
		quickPurchase();
	});
}

(function () {
	colorSwatches();
	quickPurchase();
})();

function toggleCheck(id){
	const element = document.getElementById(id);
	element.checked = !element.checked;
}



async function PCcheckForGift(cart){
  console.log('Revisa si hay Gift')
  let sku_list = ['9909909_000250','9909909_000500','9909909_000600','9909909_000700','9909909_000800','9909909_000900','9909909_001000','9909909_002000']
  for(let item of cart.items){
    if(sku_list.includes(item.sku)){
      return true
    }
  }
  return false
}

async function PCgetCurrentCart() {
	let cart
    await fetch('/cart.js')
    .then(response => {
      if (!response.ok) {
        return response.json().then(error => { throw new Error(error.message); });
      }
      return response.json();
    })
    .then(data => {
        cart = data
    })
    .catch((error) => {
      console.error('Error:', error);
    });
    return cart
  }

function PChandleErrorMessage(productid, errorMessage = false) {
	console.log(productid)
	let errorMessageWrapper = document.querySelector(".product-form__error-message-wrapper.pid-"+productid);
	if (!errorMessageWrapper) return;
	errorMessageContainer = errorMessageWrapper.querySelector(
			".product-form__error-message"
		);

	errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

	if (errorMessage) {
		errorMessageContainer.textContent = errorMessage;
	}
}